
import MButton from "@/components/MButton.vue";
import { isProd, isStg } from "@/env";
import store from "@/store";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    MButton
  }
})
export default class Invoice extends Vue {
  passkey = "";
  selectedMonth = "";
  selectedDay = "";

  async execute() {
    if (!this.passkey) return;
    if (!this.selectedDay) return;
    if (!this.selectedMonth) return;

    try {
      store.commit("START_LOADING", "数分お待ちください。");
      const url = isProd
        ? "https://asia-northeast1-mingaku-jp.cloudfunctions.net/create_invoices"
        : isStg
        ? "https://asia-northeast1-mingaku-st.cloudfunctions.net/create_invoices"
        : "https://asia-northeast1-mingaku-jp-dev.cloudfunctions.net/create_invoices";

      const key = `${+this.selectedMonth - 1}${this.selectedDay}${
        this.passkey
      }`;

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ key })
      });
      const data = await res.json();
      console.log("【レスポンス】");
      console.log(data);

      if (!res.ok || !data.ok) {
        throw new Error(data.message || `HTTP ${res.status}`);
      }

      store.commit("END_LOADING");
      alert("処理が完了しました。スラックを確認してください。");
    } catch (e) {
      console.error(e);
      alert(
        `エラーが発生しました。\nエラー内容が不明な場合は開発者にお問い合わせください。\n${
          e instanceof Error ? e.message : e
        }`
      );
    } finally {
      store.commit("END_LOADING");
    }
  }
}
